import { Brand, createBranded } from '@deltasierra/type-utilities';

export type Uri = Brand<string, 'Uri'>;
export const Uri = createBranded<Uri>();
